import { EventTriggerEnum } from "@enums/event-trigger.enum";

export const formatText = (list: any[], field: string, text: string): any[] => {
  return list.filter(item => item[field].toLowerCase().includes(text.toLowerCase()));
}

export const formatAccomodationText = (list: any[], field: string, text: string): any[] => { 
  return list.filter(item => item['accomodationTranslationDto']['accomodation'][field].toLowerCase().includes(text.toLowerCase()));
}


export function normalizeLink(link: string | undefined) {
  if (!link) return null;

  if (/^https?:\/\//i.test(link)) return link;

  return `https://${link}`;
};

export const triggerPhone = (tel: string) => {
  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: EventTriggerEnum.TELEPHONE, data: { tel } }));
  }else{
    window.location.href = `tel:${tel}`;
  }
}

export const triggerMail = (mail: string) => {
  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: EventTriggerEnum.EMAIL, data: { mail } }));// manda un messaggio al native
  }else{
    window.location.href = `mailto:${mail}`; //apre il client di posta
  }
}

export const triggerShare = async (url: string, title: string|undefined, text: string) => {
  if ((window as any).ReactNativeWebView) { 
    (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: EventTriggerEnum.SHARE, data: {
          title: title,
          text: text,
          url: url
        } }));
  }else{
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url
        });
      } catch (error) {
        console.error("Errore condivisione", error);
      }
    } else {
      try {
        await navigator.clipboard.writeText(url);
        alert("Link copiato negli appunti!");
      } catch (error) {
        console.error("Errore copia link", error);
      }
    }
  }
}


export const sanitizeHtml = (html: string): string => {
  const allowedTags = ['p', 'br', 'strong', 'em', 'h1', 'h2', 'h3', 'ol', 'ul', 'li', 'span'];
  
  // Rimuove script ed elementi potenzialmente pericolosi
  html = html.replace(/<\/?(script|iframe|object|embed)[^>]*>/gi, '');

  // Rimuove javascript: negli href
  html = html.replace(/href=['"]javascript:[^'"]*['"]/gi, '');

  // Rimuove event handler tipo onclick, onerror ecc.
  html = html.replace(/ on\w+="[^"]*"/gi, '');
  html = html.replace(/ on\w+='[^']*'/gi, '');

  // Filtra tag non consentiti (li rimuove ma lascia il contenuto interno)
  html = html.replace(/<\/?([a-z0-9]+)([^>]*)>/gi, (match, tag) => {
    return allowedTags.includes(tag.toLowerCase()) ? match : '';
  });

  return html;
}
